<template>
	<div class="tabs-form">
		<el-form :inline="true" class="form" ref="form">
			<div>
				<el-form-item prop="name">
          <InputTopTip v-model="searchParams.name" placeholder="课件名称" :marginTop="11">
            <el-input
              v-model="searchParams.name"
              class="width-264"
              @keyup.enter.native=";(page = 1), searchResult()"
              placeholder=""
              size="small"
            ></el-input>
          </InputTopTip>
        </el-form-item>
        <el-form-item prop="bbb">
          <el-date-picker
            v-model="searchParams.bbb"
            type="daterange"
            size="small"
            range-separator="——"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change=";(page = 1), searchResult()"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
				</el-form-item>
        <el-form-item prop="publisher_id">
          <InputTopTip v-model="searchParams.publisher_id" placeholder="出版社" :marginTop="11">
            <el-select
              v-model="searchParams.publisher_id"
              size="small"
              placeholder=""
              class="width-121"
              @change=";(page = 1), searchResult()"
            >
              <el-option v-for="item in publisherIdTags" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </InputTopTip>
        </el-form-item>
        <el-form-item prop="tag_value">
          <InputTopTip v-model="searchParams.tag_value" placeholder="标签" :marginTop="11">
            <el-select
              v-model="searchParams.tag_value"
              size="small"
              placeholder=""
              class="width-121"
              @change=";(page = 1), searchResult()"
            >
              <el-option v-for="item in tagValue.slice(1)" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </InputTopTip>
        </el-form-item>
        <el-form-item prop="license_batch">
          <InputTopTip v-model="searchParams.license_batch" placeholder="激活码" :marginTop="11">
            <el-input
              v-model="searchParams.license_batch"
              class="width-264"
              @keydown.enter.native.prevent="(page = 1), searchResult()"
              placeholder=""
              size="small"
            ></el-input>
          </InputTopTip>
        </el-form-item>
			</div>
			<el-form-item class="form-reset">
				<el-button
					type="primary"
					@click=";(page = 1), searchResult()"
					size="small"
					style="margin-right: 15px; width: 70px;"
					>搜索</el-button
				>
				<el-button @click="resetForm('form')" size="small" style="width: 70px;">重置</el-button>
			</el-form-item>
		</el-form>

		<div class="table">
      <div _flex="~ row-reverse" _m="b-10px">
        <el-button
          size="small"
          icon="el-icon-delete"
          :style="multipleSelection.length <= 0 && 'color: #4b4b4b !important;background: #9f9f9f !important'"
          :disabled="multipleSelection.length === 0"
          @click="batchDelete()"
          v-if="multipleSelection.length > 0"
          >批量删除</el-button
        >
      </div>
			<el-table stripe style="width: 100%; min-height: 570px;" :data="tableData" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="60" align="center"></el-table-column>
        <el-table-column prop="textbook.text_name" label="课件名称"></el-table-column>
        <el-table-column label="已激活 / 未激活">
          <template slot-scope="scope">
            <span _text="[#FF5E2A]">{{ `${scope.row?.use || scope.row?.use} /` }} </span>
            <span>{{ scope.row?.not_use || scope.row?.not_use }}</span>
          </template>
        </el-table-column>
        <el-table-column label="标签" width="80px" align="center">
          <template slot-scope="scope">
            <span :style="
              {
                background: tagValue.find(item => item.id == (scope.row?.tag_value || 0))?.background,
                color: tagValue.find(item => item.id == (scope.row?.tag_value || 0))?.color,
                padding: '13px 10px',
                borderRadius: '14px',
                fontWeight: '600',
              }"
            >
              {{ tagValue.find(item => item.id == (scope.row?.tag_value || 0))?.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="creator.realname" label="操作人"></el-table-column>
        <el-table-column prop="textbook.publisher.name" label="出版社"></el-table-column>
        <el-table-column prop="created_at" label="时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <div _flex="~">
              <el-tooltip placement="top" effect="light"
                v-if="
                  ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value) ||
                  ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value) ||
                  ($store.state.user.userInfo.type === $api.account.types.TEACHER.value) ||
                  ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SA20001`]))
                "
              >
                <div slot="content">查看</div>
                <div
                  class="icon-circle"
                  :style="{
                    background: 'white',
                    cursor: 'pointer',
                  }"
                  _border="1px solid [#ebeef5]"
                  @click="goDetail(row)"
                >
                  <i aria-hidden="true" class="el-icon-view" style="color: #ff7143;"></i>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" effect="light" _m="l-5px"
                v-if="
                  ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value) ||
                  ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value) ||
                  ($store.state.user.userInfo.type === $api.account.types.TEACHER.value) ||
                  ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SA20002`]))
                "
              >
                <div slot="content">删除</div>
                <div
                  class="icon-circle"
                  :style="{
                    background: 'white',
                    cursor: 'pointer',
                  }"
                  @click="promptRemove([row.batch_id])"
                >
                  <svg
                    class="icon"
                    aria-hidden="true"
                    style="width: 100%; height: 100%; outline: none; box-shadow: none;"
                  >
                    <use xlink:href="#icon-deltred"></use>
                  </svg>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
			</el-table>
			<div class="pagination">
				<div>总计：{{ total }}条/{{ last_page }}页</div>
				<el-pagination
					:current-page.sync="page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="page_size"
					:total="total"
					background
					layout="prev, pager, next, jumper, sizes, slot"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
				>
				</el-pagination>
			</div>
		</div>

	</div>
</template>
<script>
import { mapValues } from 'lodash'
export default {
	data() {
		return {
      tagValue: [
        { id: 0, name: '', background: '', color: '' },
        { id: 1, name: '入校', background: '#FFEBEB', color: '#E86363' },
        { id: 2, name: '测试', background: '#E0F8E3', color: '#428D47' },
      ],
      page: 1,
			page_size: 10,
			last_page: '',
      total: 0,
      tableData: [],
      searchParams: {
        name: '',
        bbb: '',
        publisher_id: '',
        tag_value: '',
        license_batch: ''
      },
      multipleSelection: [],
      publisherIdTags: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
	},
	created() {
    this.getPublisherId()
    try {
      const { page, page_size, name, start, end, publisher_id, tag_value, license_batch } = this.$store.state.searchParams[this.$route.name]
      this.page = page
      this.page_size = page_size
      this.searchParams.name = name
      this.searchParams.bbb = [start, end]
      this.searchParams.publisher_id = Number(publisher_id) || ''
      this.searchParams.tag_value = Number(tag_value) || ''
      this.searchParams.license_batch = license_batch
      this.searchResult()
    } catch (_) {
      this.searchResult()
    }
	},
	methods: {
    async getPublisherId() {
			const { data } = await this.$api.question_set.getPublisherId({
        page_size: 99
      })
			this.publisherIdTags = data
		},
    resetForm(formName) {
			this.$refs[formName].resetFields()
      this.searchParams = mapValues(this.searchParams, () => '')
      this.page = 1
			this.searchResult()
		},
    handleCurrentChange(val) {
      this.page = val
      this.searchResult()
    },
    handleSizeChange(val) {
      this.page = 1
      this.page_size = val
      this.searchResult()
    },
    // 列表搜索
    async searchResult() {
      const params = {
				page_size: this.page_size,
				page: this.page,
        name: this.searchParams.name,
        start: this.searchParams.bbb ? this.searchParams.bbb[0] : '',
        end: this.searchParams.bbb ? this.searchParams.bbb[1] : '',
        publisher_id: this.searchParams.publisher_id,
        tag_value: this.searchParams.tag_value,
        license_batch: this.searchParams.license_batch
      }
      this.$store.commit('setSearchParams', { key: this.$route.name, params})
			const data = await this.$api.user.httpGet('textbook-license', params)
			this.tableData = data.data
			this.total = data.meta.total
			this.last_page = data.meta.last_page
    },
    handleSelectionChange(val) {
			this.multipleSelection = val
		},
    // 跳转详情页，将列表的激活码搜索值通过 query 带入
    goDetail(row) {
      const license = (this.searchParams.license_batch || '').trim()
      const query = {
        name: row.textbook.text_name,
        num: row.count,
        textbook_id: row.textbook_id
      }
      if (license) query.license = license
      this.$router.push({
        name: 'keyManagementView',
        params: { id: row.batch_id },
        query
      })
    },
    batchDelete() {
      if (this.multipleSelection.length <= 0) return
			this.$confirm('该操作将会删除教材导出激活码信息，是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					const params = this.multipleSelection.map(item => {
						return item.batch_id
					})
					await this.$api.resource.hiddenKey({
						ids: params
					})
					this.page = 1
					this.searchResult()
				})
				.catch(() => {})
    },
    promptRemove(list) {
			this.$confirm('该操作将会删除教材导出激活码信息，是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					await this.$api.resource.hiddenKey({
						ids: list
					})
					this.page = 1
					this.searchResult()
				})
				.catch(() => {})
    }
  },
}
</script>
<style scoped lang="scss">
.box {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box:hover {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box2 {
	margin-right: 15px;
	background: #f7f8fa;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
/deep/ .el-form-item__content {
  line-height: 0 !important;
}
.form {
	padding: 15px 0px 0px 19px !important;
	display: flex;
	justify-content: space-between;
	min-height: 40px;
	background: #ffffff;
}
.table {
	margin-top: 10px;
	padding: 20px;
	display: block;
	background: #ffffff;
}
.pagination {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 26px;
}
.icon-circle {
	width: 28px;
	height: 28px;
	border-radius: 100%;
	background: #fff8f5;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.width-264 {
	width: 264px;
}
.form-reset {
	display: flex;
	flex-wrap: nowrap;
  /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
  }
}
</style>
